import { IChatbotFlowModel } from '../data/models/chatbot';
import { PublicChatbotResponse } from '../data/responses/chatbot';
import { IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

export class ChatbotService extends ApiService {
  static readonly pathName = '/flow/chatbot';

  static readonly getChatbot = (id: string) => {
    return this.get<IGetOneResponse<IChatbotFlowModel>>(
      `${this.pathName}/${id}`,
    );
  };

  static readonly getPublicChatbot = (id: string, sessionId: string) => {
    return this.get<IGetOneResponse<PublicChatbotResponse>>(
      `${this.pathName}/public/${id}/${sessionId}`,
    );
  };
}
